import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Modal, Typography, Button } from '@mui/material';
import { styled } from '@mui/system';
import Iframe from 'react-iframe';
import { useIntl } from 'react-intl';

function rand() {
  return Math.round(Math.random() * 14) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();
  return {
    transform: `translate(-${top}%, -50%)`,
  };
}

const ModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '90%',
  backgroundColor: "#fff", 
  padding: 0,
  border: '2px solid #fff',
  outline: 'none',
  transform: 'none!important',
  top: 20,
  left: '0!important',
  right: '0!important',
  margin: '0 auto',
  '& .leaflet-container': {
    height: 400,
  },
  '& .leaflet-control-layers': {
    '& .leaflet-control-layers-toggle': {
      width: '30px',
      height: '30px',
      backgroundImage: `url(../../images/layers-2x.png)`,
    },
  },

  [theme.breakpoints.down('sm')]: {
    height:"85%",
    overflow:"auto"
  },
}));

const Header = styled(Typography)({
  borderBottom: 'solid 1px #e1e8ea',
  textAlign: 'center',
  padding: 20,
  fontSize: 16,
});

const ButtonContainer = styled(Grid)({
  width: '100%',
  textAlign: 'center',
  marginBottom: 20,
  marginTop: 20,
  '& .MuiBox-root': {
    display: 'inline',
    textAlign: 'center',
  },
});

const StreetViewModalCard = ({
  open,
  onCancel,
  location,
}) => {
  const [modalStyle] = React.useState(getModalStyle);
  const intl = useIntl();
  const handleClose = () => {
    // Prevent closing via backdrop click if needed
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="street-view-modal-title"
      aria-describedby="street-view-modal-description"
    >
      <ModalContent style={modalStyle}>
        <Header id="street-view-modal-title">{intl.formatMessage({ id: "location" })}</Header>
        <Box p={2}>
          <Iframe
            url={`https://www.google.com/maps/embed/v1/streetview?key=AIzaSyADIkWviX8CEOl5A2mhcGYm_U_NAiU-nb4&location=${location.latitude},${location.longitude}&heading=0&pitch=0&fov=80`}
            width="100%"
            height="500px"
            display="block"
            position="relative"
          />
        </Box>
        <ButtonContainer item xs={12}>
          {/* You can place a MUI Button here, e.g. */}
          <Button onClick={onCancel} variant="contained">{intl.formatMessage({ id: "close" })}</Button>
        </ButtonContainer>
      </ModalContent>
    </Modal>
  );
};

StreetViewModalCard.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  location: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }).isRequired,
};

export default StreetViewModalCard;
